import _typeof from "@babel/runtime/helpers/typeof";
import { getTraceId } from '@atlaskit/linking-common/utils';
var getUrlPath = function getUrlPath(url) {
  try {
    return new URL(url).pathname;
  } catch (_unused) {
    return 'Failed to parse pathname from url';
  }
};
export var getNetworkFields = function getNetworkFields(error) {
  if (error instanceof Response) {
    return {
      traceId: getTraceId(error),
      status: error.status,
      path: getUrlPath(error.url)
    };
  }
  return {
    traceId: null,
    status: null,
    path: null
  };
};
export var getErrorType = function getErrorType(error) {
  if (error instanceof Response) {
    return 'NetworkError';
  }
  if (error instanceof Error) {
    return error.name;
  }
  return _typeof(error);
};